<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1055_2253)">
      <rect width="24" height="24" rx="12" fill="#0D87EF"/>
      <path d="M12.0001 6.16699V17.8337M6.16675 12.0003H17.8334" stroke="white" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_1055_2253">
        <rect width="24" height="24" rx="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>
